import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=190c1aec&scoped=true"
import script from "./Language.vue?vue&type=script&lang=ts"
export * from "./Language.vue?vue&type=script&lang=ts"
import style0 from "./Language.vue?vue&type=style&index=0&id=190c1aec&prod&lang=scss&scoped=true"
import style1 from "./Language.vue?vue&type=style&index=1&id=190c1aec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c1aec",
  null
  
)

export default component.exports